// extracted by mini-css-extract-plugin
export default {"invalid_access":"style_invalid_access__xW0x5","page_name":"style_page_name__5GFL7"};